import GameModel from "../../../core/src/model/GameModel";
import GetGameRequest from "./GetGameRequest";
import VendorModel from "../../model/VendorModel";
import BetModel from "../../../core/src/model/BetModel";
import JackpotsModel from "../../model/JackpotsModel";
import Utils from "../../../core/src/utils/Utils";

export default class PlaceBetRequest extends GetGameRequest {
  get requestData(): any {
    let userId = GameModel?.playerConfig?.userId || undefined;
    return {
      "action": "placeBet",
      "gameId":  GameModel.apiConfig.gameId,
      "userId": userId,
      "authToken": GameModel.authToken,
      "currency": GameModel.currency,
      "casino": GameModel.casino,
      "sessionId": GameModel.sessionID,
      "playId": VendorModel.playId,
      "data": {
          "type": "spin",
          "bet": BetModel.totalBet, // Used for backwards compatibility only (causes inaccurate bet rounding issues, due to floating point computation inaccuracy). The new property 'betIndex' solves this problem!
          "betIndex" : BetModel.coinSizeIndex
      },
      'serverVersion': GameModel.apiConfig.serverVersion,
      'gameVersion': Utils.isNullOrWhiteSpace(GameModel.apiConfig.gameVersion) ? GameModel?.gameVersion : GameModel.apiConfig.gameVersion,
      'deviceInfo': Utils.getDeviceInfo(),
      'optInJackpot': JackpotsModel.playForJackpot,
      "playerToken": GameModel.playerToken
    }
  }

}